export function Loader() {
  return <div className="w-6 h-6 bg-transparent animate-spin rounded-full border-[2px] border-t-old-primary" />
}
